<div class="jumbotron jumbotron-fluid">
  <div class="container">
    <div class="d-flex flex-wrap">
      <div>
        <h1 class="display-3">JEWLScholar @MTSU</h1>
        <p class="lead">JEWLScholar@MTSU is the digital repository for Middle Tennessee State University. JEWLScholar@MTSU contains scholarly and research material from MTSU faculty, staff and students.</p>
      </div>
    </div>
    <p>It's easy for Middle Tennessee State University faculty, staff and students to submit their material to JEWLScholar@MTSU.
    </p>
    <p>To submit your material click the submit button
      <a href="https://mtsu.libwizard.com/f/ir-submit">
      <img src="https://walker.mtsu.edu/images/submitlightblue.jpg" alt="Author submission" />
      </a>
    </p>    
    <ul>
      <li><a href="http://jewlscholar.mtsu.edu/handle/mtsu/4360">FAQ</a>
      </li>
      <li><a href="http://jewlscholar.mtsu.edu/handle/mtsu/4358">Author Guidelines</a>
      </li>
      <li><a href="http://library.mtsu.edu/jewlscholar">More Info</a>
      </li>
    </ul>
  </div>
</div>
